export const Delivery = {
    LOADING_DELIVERY_LIST: "LOADING_DELIVERY_LIST",
    GET_DELIVERY_LIST: "GET_DELIVERY_LIST",
  };